import React from 'react'
import PageTitle from '../components/PageTitle'
import Layout from '../components/Layout'

const Factbook = () => (
  <Layout>
    <PageTitle name="Factbook" site="OIRA" />
    <p>
      Select OIRA's new interactive Factbook using dynamic data visualizations or the standard HTML5 Factbook.
    </p>
    <p class="sectionRED half">
      <a href="http://oira.ua.edu/factbook" target="_blank">Standard HTML5 Factbook</a>
    </p>
    <p class="sectionRED half">
      <a href="../interactiveFB/">Dynamic Interactive Factbook</a>
    </p>
  </Layout>
)

export default Factbook
